import {
  Grid,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Radio,
  useEventCallback,
} from '@mui/material';
import { TypeInitiative } from 'practice/constants/practice-management-step';
import { memo } from 'react';

interface ContentInitiativeComponentProps {
  onChange: (value: TypeInitiative) => void;
  typeSelected?: TypeInitiative;
}

const ContentInitiativeComponent = ({
  typeSelected,
  onChange,
}: ContentInitiativeComponentProps): React.ReactElement => {
  const onChangeRadioUfficio = useEventCallback(() => {
    // D'ufficio
    onChange(TypeInitiative.idUfficio);
  });

  const onChangeRadioPersona = useEventCallback(() => {
    // persona
    onChange(TypeInitiative.idPersonaLegittima);
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="iniziativa"
            id="typeInitiative"
            value={typeSelected || TypeInitiative.idPersonaLegittima}
            onChange={(event) => {
              if (event.target.value === TypeInitiative.idPersonaLegittima) {
                onChangeRadioPersona();
              } else {
                onChangeRadioUfficio();
              }
            }}
          >
            <FormControlLabel
              value={TypeInitiative.idPersonaLegittima}
              control={<Radio />}
              label="Persona interessata"
            />
            <FormControlLabel
              value={TypeInitiative.idUfficio}
              control={<Radio />}
              label="D'ufficio"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>
  );
};

ContentInitiativeComponent.displayName = 'Content Initiative';

const ContentInitiative = memo(ContentInitiativeComponent);

export default ContentInitiative;
